// extracted by mini-css-extract-plugin
module.exports = {"contaner":"ShortcutsBar_contaner__3NDmZ","tips":"ShortcutsBar_tips__Gzn26"};